module.exports = __webpack_public_path__ + "static/media/background.9329350a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/static/background.jpg
// module id = 96
// module chunks = 0